import React, { useState, useEffect } from "react";
import Header from "./Header";
import Leftbar from "./Leftbar";

export default function Layout({ children }) {
  // Initial state safe rakhein taaki SSR ya hydration mismatch na ho
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  useEffect(() => {
    setIsMounted(true);

    // Mount hone ke baad screen size check karein
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setShowSidebar(true);
      } else {
        setShowSidebar(false);
      }
    };

    // Initial check on load
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Jab tak component mount na ho, flicker avoid karne ke liye blank ya default render karein
  if (!isMounted) {
    return null;
  }

  return (
    <div
      className={showSidebar ? "show-sidebar" : ""}
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin6"
      data-sidebartype={showSidebar ? "full" : "mini-sidebar"}
      data-sidebar-position="fixed"
      data-header-position="fixed"
    >
      {/* Sidebar */}
      <Leftbar sidebar={showSidebar} toggleSidebar={toggleSidebar} />

      {/* Content wrapper */}
      <div className="page-wrapper">
        {/* Main Content Area */}
        <div className="body-wrapper">
          <Header toggleSidebar={toggleSidebar} />
          <main className="container-fluid py-4">
            {children}
          </main>
        </div>
      </div>

      {/* Mobile Backdrop Overlay */}
      {showSidebar && window.innerWidth < 1200 && (
        <div
          className="dark-transparent sidebartoggler"
          onClick={() => setShowSidebar(false)}
          style={{ display: "block" }}
        />
      )}
    </div>
  );
}